import React from 'react';

const css = `
.consumer-cls-1, .consumer-cls-2 {
    fill: none;
    stroke: #003b63;
    stroke-linecap: round;
    stroke-linejoin: round;
}

.consumer-cls-2 {
    fill-rule: evenodd;
}
`;

const ConsumerIcon = () => {
    return(
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.562 19">
            <style>{css}</style>
            <circle className="consumer-cls-1" cx="17.277" cy="6.51" r="5.785"/>
            <g>
                <g>
                    <polyline className="consumer-cls-1" points="10.986 3.264 3.768 7.514 1.637 8.768 .5 6.931 5.149 4.193 5.149 1.329 7.213 1.329 7.213 2.978 11.42 .5 12.527 1.164"/>
                    <line className="consumer-cls-1" x1="3.768" y1="16.416" x2="3.768" y2="7.514"/>
                    <line className="consumer-cls-1" x1="19.33" y1="11.965" x2="19.33" y2="16.416"/>
                </g>
                <polyline className="consumer-cls-1" points="16.256 16.416 2.524 16.416 2.524 18.5 20.573 18.5 20.573 16.416 18.257 16.416"/>
            </g>
            <rect className="consumer-cls-1" x="6.974" y="9.39" width="2.832" height="2.832"/>
            <path className="consumer-cls-2" d="M17.277,6.51c-.69,0-1.25-.56-1.25-1.25s.56-1.25,1.25-1.25,1.25.56,1.25,1.25"/>
            <path className="consumer-cls-2" d="M17.277,6.51c.69,0,1.25.56,1.25,1.25s-.56,1.25-1.25,1.25-1.25-.56-1.25-1.25"/>
            <line className="consumer-cls-1" x1="17.286" y1="9.01" x2="17.286" y2="10.008"/>
            <line className="consumer-cls-1" x1="17.286" y1="3.01" x2="17.286" y2="4.01"/>
        </svg>
    )
}

export default ConsumerIcon;